import api from './api';
import { Download, DownloadFormData, ApiResponse } from '../../types/downloads.types';

export const downloadsService = {
  getAll: async (category?: string): Promise<ApiResponse<Download[]>> => {
    const params = category ? { category } : {};
    const response = await api.get<ApiResponse<Download[]>>('/api/downloads', { params });
    return response.data;
  },

  getById: async (id: number): Promise<ApiResponse<Download>> => {
    const response = await api.get<ApiResponse<Download>>(`/api/downloads/${id}`);
    return response.data;
  },

  getCategories: async (): Promise<ApiResponse<string[]>> => {
    const response = await api.get<ApiResponse<string[]>>('/api/downloads/categories');
    return response.data;
  },

  create: async (data: DownloadFormData): Promise<ApiResponse<Download>> => {
    const response = await api.post<ApiResponse<Download>>('/api/downloads', data);
    return response.data;
  },

  update: async (id: number, data: DownloadFormData): Promise<ApiResponse<Download>> => {
    const response = await api.put<ApiResponse<Download>>(`/api/downloads/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/api/downloads/${id}`);
    return response.data;
  },

  toggleStatus: async (id: number): Promise<ApiResponse<Download>> => {
    const response = await api.put<ApiResponse<Download>>(`/api/downloads/${id}/toggle-status`);
    return response.data;
  },

  uploadFile: async (file: File): Promise<ApiResponse<{ url: string; filename: string }>> => {
    const fd = new FormData();
    fd.append('document', file);
    const response = await api.post<ApiResponse<{ url: string; filename: string }>>('/api/downloads/upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};
